import { j as l } from "../../../node_modules/react/jsx-runtime.js";
import { clsx as a } from "../../../node_modules/clsx/dist/clsx.m.js";
import { memo as j, useState as b } from "react";
import e from "./ProgressSteps.module.scss.js";
import { Typography as d } from "../Typography/Typography.js";
import p from "../Icon/Icon.js";
import n from "../Flex/Flex.js";
const v = ({
  activeStep: t = 0,
  onStepClick: m,
  orientation: s = "horizontal",
  type: c,
  steps: i,
  disable: x,
  activePercentage: g = 100
}) => {
  const [f, h] = b(t);
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      className: a({
        [e.verticalOrientationContainer]: s === "vertical",
        "w-full py-300 px-200": s === "horizontal"
      }),
      children: /* @__PURE__ */ l.jsx(
        "div",
        {
          className: a(e.progressStepsContainer, {
            [e.verticalOrientation]: s === "vertical"
          }),
          children: i == null ? void 0 : i.map((o, r) => {
            const u = {
              all_disabled: !0,
              all_enabled: !1,
              next_disabled: f < r
            }[x ?? "all_enabled"];
            return /* @__PURE__ */ l.jsxs(
              n,
              {
                flexCol: s === "vertical",
                justifyStart: !0,
                itemsCenter: s === "horizontal",
                itemsStart: s === "vertical",
                justifyBetween: !0,
                "data-testid": o.testId,
                style: {
                  gap: "8px",
                  flexGrow: r === i.length - 1 ? 0 : 1,
                  cursor: u ? "not-allowed" : "pointer"
                },
                ...!u && {
                  onClick: () => {
                    f < r && h(r), m == null || m(r);
                  }
                },
                children: [
                  /* @__PURE__ */ l.jsxs(
                    n,
                    {
                      flexRow: !0,
                      itemsCenter: !0,
                      justifyBetween: !0,
                      style: { gap: "8px", flexShrink: 0 },
                      children: [
                        r >= t && c === "numbers" && /* @__PURE__ */ l.jsx(
                          "span",
                          {
                            className: a(
                              e.stepperNumbers,
                              t === r && e.activeStepperNumbers,
                              o.description && e.stepperNumbersLg
                            ),
                            children: /* @__PURE__ */ l.jsx(
                              d,
                              {
                                variant: "interface/medium/s",
                                textColor: "color/fg/inverse",
                                text: r + 1
                              }
                            )
                          }
                        ),
                        r >= t && c === "minimal" && /* @__PURE__ */ l.jsx(
                          "div",
                          {
                            className: a(
                              e.stepperDot,
                              t === r && e.activeStepperDot,
                              o.description && e.stepperDotLg
                            ),
                            style: {
                              background: t === r ? `conic-gradient(var(--ds-core-color-primary-600) ${g * 3.6}deg, var(--ds-core-color-gray-modern-200) 0deg)` : ""
                            },
                            children: /* @__PURE__ */ l.jsx(
                              "div",
                              {
                                className: a(
                                  e.stepperDotChild,
                                  e.small,
                                  t === r && e.activeStepperDotChild,
                                  o.description && e.activeStepperDotChildLg
                                ),
                                role: "button",
                                tabIndex: 0
                              }
                            )
                          }
                        ),
                        r >= t && c === "icon" && /* @__PURE__ */ l.jsx(
                          p,
                          {
                            name: "user-03",
                            size: o.description ? "xxl" : "md",
                            color: "primary",
                            className: t === r ? "text-color-fg-brand-default" : "text-color-fg-lighter"
                          }
                        ),
                        r < t && /* @__PURE__ */ l.jsx(
                          p,
                          {
                            name: c !== "icon" ? "check-circle-filled" : "check",
                            size: o.description ? "xxl" : "md",
                            color: "primary",
                            className: "text-color-fg-success-default"
                          }
                        ),
                        /* @__PURE__ */ l.jsxs(n, { flexCol: !0, children: [
                          /* @__PURE__ */ l.jsx(
                            d,
                            {
                              variant: "interface/medium/sm",
                              textColor: "color/fg/bold",
                              text: o.label
                            }
                          ),
                          /* @__PURE__ */ l.jsx(
                            d,
                            {
                              variant: "body-new/regular",
                              textColor: "color/fg/lighter",
                              text: o.description
                            }
                          )
                        ] })
                      ]
                    }
                  ),
                  r + 1 !== i.length && /* @__PURE__ */ l.jsx(
                    "div",
                    {
                      className: a(
                        s === "horizontal" ? e.divider : e.dividerVertical,
                        o.description && e.dividerVerticalIcon
                      )
                    }
                  )
                ]
              },
              r
            );
          })
        }
      )
    }
  );
}, _ = j(v);
export {
  v as ProgressSteps,
  _ as default
};
//# sourceMappingURL=ProgressSteps.js.map
